import React from "react";
import PropTypes from "prop-types";
import { List, ListItem, ListItemText } from "@material-ui/core";
import { colors, errorDivStyle } from "./UploadCommon";

// displays 'regular' errors/warnings etc in validationLog
// includes duplicates (not duplicate ID from Database, duplicate within one sheet)
const RegularErrors = props => {
  const textTransform = str => {
    if (!str) return null;
    const arr = str.match(/- (.+)\s+NOT mapped/);
    if (!arr) return str;
    if (arr.length) {
      const fieldName = arr[1].trim();
      return (
        <span>
          <b>
            &quot;
            {fieldName}
            &quot;
          </b>{" "}
          not mapped.
        </span>
      );
    }
    return str;
  };

  if (
    !props.rows.length ||
    !props.rows.some(
      row => row.level && row.level.toLowerCase() === props.level
    )
  )
    return null;
  return (
    <div
      style={{
        fontSize: "14px",
        ...errorDivStyle,
        borderColor: colors[props.level]
      }}
    >
      <List>
        {props.rows
          // .filter(row => row.level.toLowerCase() === props.level)
          .map(row => (
            <ListItem>
              <ListItemText>
                {textTransform(row.message || row.hint)}
              </ListItemText>
            </ListItem>
          ))}
      </List>
    </div>
  );
};

RegularErrors.propTypes = {
  level: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object)
};
RegularErrors.defaultProps = {
  rows: []
};
export default RegularErrors;
